
import React from "react";
import { cn } from "@/lib/utils";

interface ScriptDisplayProps {
  script: string;
  className?: string;
}

export function ScriptDisplay({ script, className }: ScriptDisplayProps) {
  return (
    <div className={cn("bg-muted p-3 rounded-md overflow-x-auto max-h-[200px] overflow-y-auto", className)}>
      <pre className="text-xs whitespace-pre-wrap break-all">
        {script}
      </pre>
    </div>
  );
}
